// extracted by mini-css-extract-plugin
module.exports = {"textLeftv1":"ContentPopupBuyBook_textLeftv1__3Fuqk","titlePopup":"ContentPopupBuyBook_titlePopup__38VBF","itemContact":"ContentPopupBuyBook_itemContact__Y7MF6"};